import { useQuery } from "@tanstack/react-query";

import { fetchDataGet } from "@/core/api/api-methods";
import { QUERY_KEYS } from "@/core/api/query-keys";
import { kycEndpoints } from "@/features/kyc/api/endpoints";
import type { KycCaseDto } from "@/features/kyc/api/dto";

/** Détail d'un dossier KYC avec ses pièces justificatives (`GET /KycCases/{id}`). */
export const useKycCase = (kycCaseId: string, enabled = true) =>
  useQuery({
    queryKey: QUERY_KEYS.KYC_CASE_DETAIL(kycCaseId),
    queryFn: () =>
      fetchDataGet<KycCaseDto>({ url: kycEndpoints.kycCases.detail(kycCaseId) }),
    retry: (failureCount, error) =>
      !/401/.test(error?.message ?? "") && failureCount < 1,
    enabled: enabled && Boolean(kycCaseId),
  });
